export const CommentsConfig = {
  DEFAULT_COMMENTS_LIMIT: 30,
  COMMENT_REACTIONS_LIMIT: 5,
  ACTIVE_APPROVAL_REQUEST_DATA_ID: 'active-approval-request',
  APPROVAL_REQUEST_WORKFLOW_DATA_NAME: 'comments_comment-workflows',
};
